import { sheetV1 } from "@otto-ec/otto-components/sheet";

export default class DiscountBenefitSheet {
  public static open(target: HTMLElement, benefitId: string, dresonRule: string, variationId: string) {
    if (!target || !(target instanceof HTMLElement || !benefitId)) return;

    sheetV1.create({
      url: `/benefit-sheet/sheet/list/${benefitId}?contextDreson=${dresonRule}&variationId=${variationId}&useOcSheet=true`,
      open: true,
    });
  }
}
